module.exports = __webpack_public_path__ + "img/twoo.f71dbad.png";